import React, { useEffect, useRef } from 'react';
import { Spin } from 'antd';

import {
  CurrentConversationStore,
  setApiConfig,
  sendMessage,
  resubmitLastMessage,
  resetStore,
} from 'stores/current-conversation';
import { loadConversationHistory } from 'stores/conversation-history';
import { UserStore, getPersonalIndexes } from 'stores/user';

import {
  QuestionInput,
  FlorenceLogo as AppLogo,
  ConversationControls,
  ConversationMessageDisplay,
} from 'ui/molecules';

import './conversation.css';

const SHOW__COVNERSATION_CONTROLS = false;

const Conversation = () => {
  const messagesEndRef = useRef(null);

  const apiConfig = UserStore.useState((s) => s.apiConfig);
  const personalFiles = UserStore.useState((s) => s.personalFiles);
  const indexes = UserStore.useState((s) => s.personalIndexes);
  const siteIndexes = CurrentConversationStore.useState(
    (s) => s.indexContextIndexes,
  );

  const messages = CurrentConversationStore.useState((s) => s.messages);
  const currentConversationId = CurrentConversationStore.useState((s) => s.id);
  const conversationIsLoading = CurrentConversationStore.useState(
    (s) => s.isLoading,
  );

  useEffect(() => {
    if (apiConfig) {
      setApiConfig(apiConfig);
      getPersonalIndexes();
    }
  }, [apiConfig]);

  useEffect(() => {
    if (apiConfig) {
      loadConversationHistory();
    }
  }, [currentConversationId, apiConfig]);

  useEffect(() => {
    if (!currentConversationId && siteIndexes.length > 0) {
      resetStore();
    }
  }, [currentConversationId, siteIndexes]);

  useEffect(() => {
    setTimeout(() => {
      if (messagesEndRef.current) {
        (messagesEndRef.current as HTMLElement).scrollIntoView({
          behavior: 'smooth',
        });
      }
    }, 200);
  }, [messages]);

  return (
    <div className="conversation-area">
      {!messages ||
        (messages.length === 0 && !conversationIsLoading && (
          <div className="center-area">
            <AppLogo monochrome />
          </div>
        ))}

      {conversationIsLoading && messages.length === 0 && (
        <div className="center-area">
          <Spin size={'large'} />
        </div>
      )}

      {messages && messages.length > 0 && (
        <ConversationMessageDisplay
          messages={messages}
          messagesEndRef={messagesEndRef}
          resubmitAction={resubmitLastMessage}
          currentConversationId={currentConversationId}
          personalFiles={personalFiles}
          indexes={indexes}
        />
      )}
      <div className="conversation-input-wrapper">
        <div className="conversation-input-controls">
          <QuestionInput
            onSubmit={(m: string) => {
              sendMessage(m);
            }}
          />
          {SHOW__COVNERSATION_CONTROLS && (
            <ConversationControls
              onSelectFileClick={() => {}}
              onFileUploadClick={() => {}}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Conversation;
